import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/redux/root'
import { setSelectedScenario } from 'src/redux/slices/analysis/reducers'
import {
  selectScenario,
  selectSortedScenarioNames
} from 'src/redux/slices/analysis/selectors'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

type ScenarioSelectorProps = {
  action: (arg: string | null) => any
  selector?: (state: RootState) => string | null
  label: string
  helperText: string
  error?: string
  usesAllSelect?: boolean
}
const ScenarioSelector: React.FC<ScenarioSelectorProps> = ({
  action,
  selector,
  label,
  helperText,
  error,
  usesAllSelect,
}) => {
  const dispatch = useDispatch()
  const scenarios = useSelector(selectSortedScenarioNames)
  const options = scenarios.map((scenario, i) => ({ label: scenario, value: scenario }))
  const value = useSelector(selector ? selector : selectScenario) // default to selecting the active scenario

  const handleChange = useCallback(
    (e: React.ChangeEvent<{ value: unknown; name?: unknown }>) => {
      // default to selecting the active scenario
      const val = e.target.value as string
      const final = val === '' ? null : val
      dispatch(action ? action(final) : setSelectedScenario(final))
    },
    [dispatch, action],
  )

  const helper = helperText ? helperText : 'Select a scenario to analyze'

  return (
    <FormControl fullWidth error={error ? true : false} size='small'>
      <InputLabel id='scenario-selector-label'>{label ? label : 'Scenario'}</InputLabel>

      <Select
        labelId='scenario-filter-label'
        id='scenario-filter'
        value={value ? value : ''}
        onChange={handleChange}
      >
        {options.map(({ value, label: _label }) => (
          <MenuItem value={value} key={`scenario-option-${value}`}>
            {_label}
          </MenuItem>
        ))}
        {usesAllSelect && <MenuItem value={''}>All Scenarios</MenuItem>}
      </Select>
      <FormHelperText>{error ? error : helper}</FormHelperText>
    </FormControl>
  )
}

export default ScenarioSelector
